




































































































import { Prop, Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import DeliveryPoint from '@/dto/deliveries/DeliveryPoint'
import deliveryPointsStore from '@/stores/DeliveryPointsStore'
import { Errors } from '@/dto/ErrorsResponse'
import { NotifyHelper } from 'vue-kit'

@Component
export default class PointForm extends Vue {
  @Prop(Object)
  model: DeliveryPoint

  isPending: boolean = false
  deliveryPointsStore = deliveryPointsStore

  get errors(): Errors {
    return this.deliveryPointsStore.validationErrors
  }

  showDeliveryPoints() {
    this.$router.replace({ query: {} })
  }

  saveDeliveryPoint() {
    this.isPending = true

    this.deliveryPointsStore
      .saveDeliveryPoint(this.model)
      .then(() => NotifyHelper.success('Точка выдачи сохранена'))
      .catch(errors => {
        this.deliveryPointsStore.setErrors(errors)
      })
      .catch(() => {
        NotifyHelper.error('Ошибка сервера')
      })
      .finally(() => (this.isPending = false))
  }
}
